
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerEditor()
    export class PoPurInvoiceEditors extends Serenity.LookupEditorBase<Serenity.LookupEditorOptions, PoPurInvoiceRow>{

        constructor(hidden: JQuery) {
            super(hidden);
        }

        protected getLookupKey() {
            return PoPurInvoiceRow.lookupKey;
        }

        // protected getItemText(item, lookup) {
        //     return super.getItemText(item, lookup) + ' [' + item.MbFirstName+']';
        // }
    }
}
